interface DonationLink {
  hebrew: string;
  english: string;
}

interface DonationLinksCollection {
  general: DonationLink;
  general50: DonationLink;
  general100: DonationLink; // Added for 100 NIS donation
  general180: DonationLink; // Added for 180 NIS donation
  general360: DonationLink; // Added for 360 NIS donation
  general500: DonationLink; // Added for 500 NIS donation
  projects: {
    [key: string]: DonationLink;
  };
}

const donationLinks: DonationLinksCollection = {
  // General donation links
  general: {
    hebrew: "https://mrng.to/y6Ls4SEHBF",
    english: "https://mrng.to/y6Ls4SEHBF", // Using the same link for now, update if needed
  },
  general50: {
    hebrew: "https://mrng.to/rVZdIIASAc",
    english: "https://mrng.to/gQMXJMsxTy", // Updated with the correct link
  },
  general100: {
    hebrew: "https://mrng.to/ERRnWHuNLu",
    english: "https://mrng.to/IWEFHTMpyx",
  },
  general180: {
    hebrew: "https://mrng.to/n4UUakI7pe",
    english: "https://mrng.to/J3oqP3ZH1i",
  },
  general360: {
    hebrew: "https://mrng.to/0cFRYX6VTY",
    english: "https://mrng.to/v94KFAJiOf",
  },
  general500: {
    hebrew: "https://mrng.to/t1gyeNRMdh",
    english: "https://mrng.to/F4lkZm4olX",
  },
  // Project-specific donation links
  projects: {
    cleaning: {
      hebrew: "https://mrng.to/cMs0TiPd1F",
      english: "https://mrng.to/bHwKRsXvpU", // Updated with the correct English link
    },
    baby: {
      hebrew: "https://mrng.to/YI1G6hEOE5",
      english: "https://mrng.to/HYv7dZXrs7",
    },
    batmitzvah: {
      hebrew: "https://mrng.to/JvXOld7j5y",
      english: "https://mrng.to/NQBx3LOpE9",
    },
    tubshvat: {
      hebrew: "https://mrng.to/54O9o4c8px",
      english: "https://mrng.to/sxDCSedRSi",
    },
    // Placeholders for other projects - add actual links when available
    school: {
      hebrew: "https://mrng.to/trV8FNyJnR",
      english: "https://mrng.to/cvGMfX2apc",
    },
    chanukah: {
      hebrew: "https://mrng.to/EogwOstZa5",
      english: "https://mrng.to/f8a8jXTPGc",
    },
    hospital: {
      hebrew: "https://mrng.to/Pq3gVt11um",
      english: "https://mrng.to/vwAfLHiZdx",
    },
    soldiers: {
      hebrew: "https://mrng.to/y3t6NbcRnK",
      english: "https://mrng.to/MwwOVNUFuI",
    },
  },
};

export default donationLinks;